import type {Auth} from 'typings/portaro.be.types';
import type ServerUrlsDataService from './server-urls.data-service';
import type {ModalDialogService} from 'shared/modal-dialogs/modal-dialog.service';
import type WalkerService from 'shared/services/walker.service';
import {isEmptyObject} from 'shared/utils/custom-utils';

export class CatalogueSelectionLoginListener {

    public static readonly serviceName = 'catalogueSelectionLoginListener';

    private catalogueSelectionOpened = false;

    /*@ngInject*/
    constructor(private serverUrlsDataService: ServerUrlsDataService,
                private modalDialogService: ModalDialogService,
                private walker: WalkerService) {
    }

    public async update(newAuth: Auth): Promise<void> {
        if (!newAuth.evided || this.catalogueSelectionOpened) {
            return;
        }

        const departmentsByUrls = await this.serverUrlsDataService.getDepartmentUrl();
        if (!isEmptyObject(departmentsByUrls)) {
            try {
                this.catalogueSelectionOpened = true;
                const catalogueUrl = await this.modalDialogService.openModalWindowAndGetPayload('catalogueSelection', departmentsByUrls).finally(() => this.catalogueSelectionOpened = false);
                this.walker.newPage(catalogueUrl);

                // get time to redirect
                return new Promise((resolve) => setTimeout(resolve, 2000));
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
            } catch (e) {
                //
            }
        }
    }
}